import React from "react";

export const AppContext = React.createContext<AppContextType>(null);

export interface AppContextType {
    navigate: (path: string) => void;
    refreshRoute: () => void;
    registerDropGrid: (
        handler: (position: { x: number; y: number }, data?: any) => void,
    ) => void;
    deregisterDropGrid: (
        handler: (position: { x: number; y: number }, data?: any) => void,
    ) => void;
    evaluateDropGrids: (position: { x: number; y: number }, data?: any) => void;
    verifyCredentials: () => Promise<boolean>;
}
